/**
 * Storyboard journeys (doc 147 §6.6 E7). Curated user-journey definitions:
 * an ordered list of steps, each step references a surface, the underlying
 * entities, and the events fired. The view walks them with a play/pause
 * control.
 */

export interface StoryboardStep {
  title: string;
  description: string;
  /** Surface ids the user sees at this step. */
  surfaces: string[];
  /** Entities written or read. */
  entities: string[];
  /** Events fired during this step. */
  events: string[];
}

export interface Storyboard {
  id: string;
  title: string;
  persona: string;
  steps: StoryboardStep[];
}

export const STORYBOARDS: readonly Storyboard[] = [
  {
    id: 'onboarding',
    title: 'New-user onboarding',
    persona: 'first-time user',
    steps: [
      {
        title: 'Sign in',
        description: 'User signs in with Google. Profile is created.',
        surfaces: ['sign_in'],
        entities: ['User', 'UserProfile'],
        events: ['user_signed_in'],
      },
      {
        title: 'Set intent',
        description: 'User picks a financial intent (save, invest, budget).',
        surfaces: ['onboarding_intent'],
        entities: ['FinancialIntent'],
        events: ['intent_set'],
      },
      {
        title: 'Link first account',
        description: 'Plaid Link opens; user picks bank + connects.',
        surfaces: ['plaid_link'],
        entities: ['PlaidConnection', 'Account'],
        events: ['account_linked', 'plaid_sync_started'],
      },
      {
        title: 'First transaction sync',
        description: 'Initial transaction backfill completes (~30 days).',
        surfaces: ['sync_progress'],
        entities: ['Transaction'],
        events: ['transaction_created'],
      },
      {
        title: 'First insight',
        description: 'AgentInsight surfaces a top spending category.',
        surfaces: ['ai.insight_card'],
        entities: ['AgentInsight'],
        events: ['insight_generated'],
      },
    ],
  },
  {
    id: 'first-goal',
    title: 'Create first goal',
    persona: 'engaged user',
    steps: [
      {
        title: 'Open Goals hub',
        description: 'User taps Goals tab.',
        surfaces: ['goals_hub'],
        entities: [],
        events: [],
      },
      {
        title: 'Pick goal template',
        description: 'Pick from emergency fund / vacation / home / custom.',
        surfaces: ['goal_template_picker'],
        entities: [],
        events: [],
      },
      {
        title: 'Save goal',
        description: 'Goal persisted; contribution schedule proposed.',
        surfaces: ['goal_detail'],
        entities: ['Goal', 'GoalContribution'],
        events: ['goal_created'],
      },
    ],
  },
];
